import type { QueryClient } from '@tanstack/react-query';

export const documentsRegenSignalKey = (policyId: string) =>
  ['documents-regen-signal', policyId] as const;

export function bumpDocumentsRegenSignal(queryClient: QueryClient, policyId: string) {
  const key = documentsRegenSignalKey(policyId);
  queryClient.setQueryData<number>(key, prev => (prev ?? 0) + 1);
}
